"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StampTypePanel = void 0;
var markerjs2_1 = require("markerjs2");
var customStamps_1 = __importDefault(require("./customStamps"));
var StampTypePanel = /** @class */ (function (_super) {
    __extends(StampTypePanel, _super);
    function StampTypePanel(title, icon, stampType) {
        if (stampType === void 0) { stampType = Object.keys(customStamps_1.default)[0]; }
        var _this = _super.call(this, title, icon) || this;
        _this.stampTypeButtons = new Map();
        _this.title = title;
        _this.icon = icon;
        _this.stampType = stampType;
        _this.onStampSelected = function () { }; // Default no-op function
        return _this;
    }
    StampTypePanel.prototype.getUi = function () {
        var container = this.createContainer();
        this.createStampButtons(container);
        this.setCurrentStampType(this.stampType);
        return container;
    };
    StampTypePanel.prototype.createContainer = function () {
        var container = document.createElement('div');
        container.style.display = 'flex';
        container.style.flexDirection = 'row';
        container.style.alignItems = 'center';
        container.style.justifyContent = 'center';
        return container;
    };
    StampTypePanel.prototype.createStampButtons = function (container) {
        var _this = this;
        Object.entries(customStamps_1.default).forEach(function (_a) {
            var key = _a[0], stamp = _a[1];
            if (stamp.name === 'stampMark')
                return; // skip the stampMark icon
            var button = _this.createStampButton(key, stamp.name, stamp.icon);
            container.appendChild(button);
            _this.stampTypeButtons.set(stamp.name, button);
        });
    };
    StampTypePanel.prototype.createStampButton = function (key, stampName, stampIcon) {
        var _this = this;
        var button = document.createElement('div');
        button.classList.add('__markerjs2__0_toolbox_button', "__markerjs2__0_toolbox-button_".concat(key.toLowerCase()));
        button.setAttribute('role', 'button');
        button.setAttribute('aria-label', stampName);
        button.setAttribute('title', stampName);
        button.setAttribute('data-action', "".concat(stampName.toLowerCase(), "-panel"));
        button.addEventListener('click', function (e) { return _this.handleStampPanelButtonClick(e); });
        var svgElement = this.createSvgElement(stampIcon);
        button.appendChild(svgElement);
        this.styleButton(button);
        return button;
    };
    StampTypePanel.prototype.createSvgElement = function (stampIcon) {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = stampIcon;
        var svgElement = tempDiv.firstElementChild;
        svgElement.classList.add('__markerjs2__0_toolbox_button_icon');
        svgElement.setAttribute('width', '24');
        svgElement.setAttribute('height', '24');
        svgElement.style.transform = 'scale(1.5)';
        svgElement.style.overflow = 'visible';
        return svgElement;
    };
    StampTypePanel.prototype.styleButton = function (button) {
        Object.assign(button.style, {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 4px',
            fill: 'white',
            border: '2px solid transparent',
        });
    };
    StampTypePanel.prototype.handleStampPanelButtonClick = function (e) {
        var clickedElement = e.currentTarget;
        var stampType = clickedElement.getAttribute('title');
        if (stampType) {
            this.setCurrentStampType(stampType);
            this.onStampSelected(stampType);
        }
        else {
            console.warn('No valid stamp type found.');
        }
    };
    StampTypePanel.prototype.setCurrentStampType = function (stampType) {
        var _this = this;
        this.stampType = stampType;
        this.stampTypeButtons.forEach(function (button, key) {
            var _a;
            var toolboxAccentColor = ((_a = _this.uiStyleSettings) === null || _a === void 0 ? void 0 : _a.toolboxAccentColor) || 'transparent';
            button.style.borderColor = key === stampType ? toolboxAccentColor : 'transparent';
        });
    };
    StampTypePanel.typeName = 'StampTypePanel';
    return StampTypePanel;
}(markerjs2_1.ToolboxPanel));
exports.StampTypePanel = StampTypePanel;
